import styled from "styled-components";
// import { Link as LinkR } from "react-router-dom";
// import { Link as LinkS } from "react-scroll";

export const Nav = styled.nav`
  background: ${(props) =>
    props.theme === "dark" ? "rgb(35, 35, 35)" : "#fff"};
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: ${(props) =>
    props.theme === "dark" ? "none" : "rgb(0 0 0 / 5%) 0px 5px 10px;"};
  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0 24px 0 16px;
  max-width: 1100px;
`;
export const NavLogo = styled.a`
  color: red;
  justify-self: flex-start;
  cursor: pointer;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-left: 0px;
  font-weight: bold;
  text-decoration: none;
`;
export const Image = styled.img`
  height: 70%;
`;
export const MobileIcon = styled.div`
  display: none;
  color: ${(props) =>
    props.theme === "dark" ? "transparent" : "rgb(109, 131, 242)"};
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #fff;
  }
`;
export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  height: 80px;
`;
export const NavLinks = styled.a`
  color: ${(props) => (props.theme === "dark" ? "#fff" : "rgb(109, 131, 242)")};
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  font-weight: bolder;
  cursor: pointer;
  &::after {
    content: "";
    display: block;
    width: 0;
    margin-top: 30px;
    height: 6px;
    background: #00a0a0;
    transition: color 0.4s;
  }
  &:hover {
    color: #01bf71;
  }
  &.active {
    border-bottom: 3px solid #01bf71;
  }
`;

export const ToggleSwitchWrapper = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
